import React, { useEffect, useState } from "react";
import VerticalProgressBar from "../VerticalProgressBar";
import { t } from "i18next";
import { dashBoardformatDate } from "../../../utils";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { getUserMembership } from "../../../helpers/utils/Utils";

const ManageCBKTransactions = ({ handleScroll, fundsFromCBKplus, userDataPercentage, unpaidTransactionData,repaidTransactionData,limit,usedAmountValue }) => {
  // Scroll event listener to detect bottom of the page
  const navigate = useNavigate();
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const userMembershipData = getUserMembership(loggedResponse)
  const [result,setResult] = useState(false);
  useEffect(() => {
    if(userDataPercentage === 0){
      setResult(true);
    }
  },[]);
  const onAcptBtnClick = () =>{
    navigate('/AccountServices/Spending/TransferMoney') 
  }
  // useEffect(() => {
  // alert(JSON.stringify(repaidTransactionData))},[])

  const handleTermsClick = () =>{
    if (accessTokenToApi === undefined || accessTokenToApi == null) {
      return;
  }
  else {
      navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions',   url:
        userMembershipData?.membershipType === "Plus" ||
        userMembershipData?.membershipType === "Trial"
        ? "CoveredByKudzuPlusTerms"
        : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey } });
  
  }
  }


  return (
    <>
      <div className='lg:w-[70%] sm:w-[81%] w-full '>
        <>
          <div className='hide-scrollbar max-h-[700px] overflow-y-auto' onScroll={handleScroll}>
            {fundsFromCBKplus.map((settings, index) => (
              <div key={index} className='mt-10 flex justify-between md:h-[123px] sm:h-[140px] h-[123px]'>
                <div>
                  <p className='lg:text-[20px] md:text-[18px] 
                                                    sm:text-[17px] text-[17px] font-hanken-grotesk 
                                                    leading-[30px] sm:font-[500] font-[600] text-[var(--settings-clrs-pop)]'>
                    {settings.title}
                  </p>
                  <div className='w-[240px] sm:w-[500px]  mt-4 lg:text-[17px]  md:text-[13px] sm:text-[14px] text-[14px] font-hanken-grotesk lg:leading-[20px] md:leading-[18px] sm:leading-[23px] leading-[20px] sm:font-[400] font-[500]  text-[var(--settings-pop-content-clr)]'>
                    {settings.content}
                  </div>
                </div>
              </div>
            ))}
            <div className='my-10'>
              <VerticalProgressBar usedMoneyValue={"$" + usedAmountValue} gradientPercentage={userDataPercentage + "%"} limit={limit} />
            </div>
            <p className=' font-hanken-grotesk leading-[30px] text-[10px] font-[700] text-[#779CE5] uppercase tracking-[2px] mb-5'>
              {t('unpaid')}
            </p>
            {unpaidTransactionData && unpaidTransactionData.length > 0 ? (
              unpaidTransactionData.map((item, index) => (
                <div key={index} className="flex justify-between items-center mb-[15px]">
                  <div>
                    <p className="font-hanken-grotesk leading-[24px] text-[16px] text-[#FFFFFF]">
                      {item.Description}
                    </p>
                    <p className="font-hanken-grotesk leading-[24px] text-[14px] text-[#94C3E8]">
                      {dashBoardformatDate(item.TransactionDate)}
                    </p>
                  </div>
                  <div className="font-hanken-grotesk leading-[24px] text-[16px] text-[#30BC89] bg-clip-text ">
                    {/* // style={{
                    //   background: 'linear-gradient(to right, #2965FB, #4B70B9, #30BC89)',
                    //   WebkitBackgroundClip: 'text',
                    // }}> */}
                    {parseFloat(item?.Amount)?.toFixed(2)}
                  </div>
                </div>
              ))
            ) : (
              <p className="font-hanken-grotesk leading-[24px] text-[14px] text-[#779CE5]">
                {t('notransaction')}
              </p>
            )}

            <p className=' font-hanken-grotesk leading-[30px] text-[10px] font-[700] text-[#779CE5] uppercase tracking-[2px] my-5'>
              {t('repaid')}
            </p>
            {repaidTransactionData && repaidTransactionData.length > 0 ? (
              repaidTransactionData.map((item, index) => (
                <div key={index} className="flex justify-between items-center mb-[15px]">
                  <div>
                    <p className="font-hanken-grotesk leading-[24px] text-[16px] text-[#779CE5]">
                      {item?.Description}
                    </p>
                    <p className="font-hanken-grotesk leading-[24px] text-[14px] text-[#779CE5]">
                      {dashBoardformatDate(item?.TransactionDate)}
                    </p>
                  </div>
                  <div className="font-hanken-grotesk leading-[24px] text-[16px] text-[#779CE5]">
                   {parseFloat(item?.Amount)?.toFixed(2)}
                  </div>
                </div>
              ))
            ) : (
              <p className="font-hanken-grotesk leading-[24px] text-[14px] text-[#779CE5]">
                {t('notransaction')}
              </p>
            )}

          </div>
          {/* <p className={`mt-4 lg:text-[15px] 
             md:text-[15px] sm:text-[14px] text-[14px] 
             font-hanken-grotesk lg:leading-[20px] md:leading-[18px]
              sm:leading-[23px] leading-[20px] sm:font-[400] font-[400] w-[500px] text-[#779CE5] ${!result?'block !pb-[92px]':''}`} style={{paddingBottom: result?'92px':'0px'}}>
            {!result?t('add_money_discl'):t('cbk_transaction_updated_text')}
          </p> */}

<p className='mt-9 sm:my-9  text-[15px] font-hanken-grotesk 
                                                    leading-[18px] font-[400] sm:w-[500px] text-[#779CE5]'>
                        {t('cbk_transaction_updated_text_update')}
                        <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('Redirect_terms_and_conditions_cbk')}</span>{t('Remaining_content_cbk')}
                      </p>


          {!result &&( <button
            style={{ color: '#FFFFFF' }}
            className={`mt-[50px] mb-[80px] lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] w-full lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold leading-[16px] disabled:opacity-30 border-[#4B70B9] border-[2.5px] focus:border-[#4B70B9] focus:border-[#3px]`}
            onClick={(event) => { onAcptBtnClick() }}>{t('addMoneyTittle')}</button>)}
         
        </>
      </div>
    </>
  );
};

export default ManageCBKTransactions;
